module.exports = __webpack_public_path__ + "img/saveMap.4aa2ca42.svg";